import { render, staticRenderFns } from "./myPersonalInfo.vue?vue&type=template&id=65bfa95f&scoped=true"
import script from "./myPersonalInfo.vue?vue&type=script&lang=js"
export * from "./myPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./myPersonalInfo.vue?vue&type=style&index=0&id=65bfa95f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bfa95f",
  null
  
)

export default component.exports